module.exports = __webpack_public_path__ + "static/media/hakusteel-3.cce9b38a.png";